/* The Nontoxic Co. — theme behaviours: cart drawer, search modal, variant picker */
(function () {
  const qs = (s, r) => (r || document).querySelector(s);
  const qsa = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* ---------------- overlay helpers ---------------- */
  function lockScroll(on) {
    document.body.style.overflow = on ? 'hidden' : '';
  }

  const Drawer = {
    open() {
      const d = qs('[data-cart-drawer]');
      const o = qs('[data-cart-overlay]');
      if (!d) return;
      d.setAttribute('data-open', 'true');
      if (o) o.setAttribute('data-open', 'true');
      lockScroll(true);
    },
    close() {
      const d = qs('[data-cart-drawer]');
      const o = qs('[data-cart-overlay]');
      if (d) d.setAttribute('data-open', 'false');
      if (o) o.setAttribute('data-open', 'false');
      lockScroll(false);
    },
  };

  const Search = {
    open() {
      const m = qs('[data-search-modal]');
      if (!m) return;
      m.setAttribute('data-open', 'true');
      lockScroll(true);
      const input = qs('[data-search-input]', m);
      if (input) { input.focus(); input.select(); }
    },
    close() {
      const m = qs('[data-search-modal]');
      if (m) m.setAttribute('data-open', 'false');
      lockScroll(false);
    },
  };

  document.addEventListener('click', function (e) {
    const open = e.target.closest('[data-cart-open]');
    if (open) { e.preventDefault(); Drawer.open(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) {
      Drawer.close(); return;
    }
    const so = e.target.closest('[data-search-open]');
    if (so) { e.preventDefault(); Search.open(); return; }
    if (e.target.closest('[data-search-close]')) { Search.close(); return; }
    const modal = qs('[data-search-modal][data-open="true"]');
    if (modal && e.target === modal) { Search.close(); }
    const mt = e.target.closest('[data-menu-toggle]');
    if (mt) {
      const nav = qs('[data-mobile-nav]');
      const isOpen = nav && nav.getAttribute('data-open') === 'true';
      if (nav) nav.setAttribute('data-open', isOpen ? 'false' : 'true');
      mt.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Drawer.close();
    Search.close();
  });

  /* ---------------- cart section refresh ---------------- */
  async function refreshCart(openAfter) {
    const res = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble');
    const data = await res.json();
    const wrap = qs('[data-cart-drawer-section]');
    if (wrap && data['cart-drawer']) {
      const parsed = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = parsed.querySelector('[data-cart-drawer-section]');
      if (fresh) wrap.innerHTML = fresh.innerHTML;
    }
    const bubble = qs('[data-cart-count]');
    if (bubble && data['cart-icon-bubble']) {
      const parsed = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
      const fresh = parsed.querySelector('[data-cart-count]');
      if (fresh) bubble.textContent = fresh.textContent;
    }
    if (openAfter) Drawer.open();
  }
  window.NTCRefreshCart = refreshCart;

  async function changeLine(key, quantity) {
    await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
    if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
    refreshCart(false);
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.getAttribute('data-line-key'), Number(btn.getAttribute('data-line-qty')));
  });

  /* ---------------- add to cart ---------------- */
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-add-to-cart-form]');
    if (!form) return;
    e.preventDefault();
    const button = qs('[data-add-button]', form);
    const original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
    })
      .then((r) => r.json())
      .then(() => refreshCart(true))
      .finally(() => {
        if (button) { button.disabled = false; button.textContent = original; }
      });
  });

  /* ---------------- promo code ---------------- */
  const PROMO_KEY = 'ntc:promo';
  function applyPromoUI() {
    const code = localStorage.getItem(PROMO_KEY);
    qsa('[data-promo-applied]').forEach((el) => {
      el.hidden = !code;
      const label = qs('[data-promo-code]', el);
      if (label && code) label.textContent = code;
    });
    qsa('[data-promo-entry]').forEach((el) => { el.hidden = !!code; });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-promo-apply]')) {
      const input = qs('[data-promo-input]');
      if (input && input.value.trim()) {
        localStorage.setItem(PROMO_KEY, input.value.trim().toUpperCase());
        input.value = '';
        applyPromoUI();
      }
    }
    if (e.target.closest('[data-promo-remove]')) {
      localStorage.removeItem(PROMO_KEY);
      applyPromoUI();
    }
    const checkout = e.target.closest('[data-checkout]');
    if (checkout) {
      const code = localStorage.getItem(PROMO_KEY);
      if (code) {
        e.preventDefault();
        window.location.href = window.Shopify.routes.root + 'discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-promo-input]')) {
      e.preventDefault();
      const btn = qs('[data-promo-apply]');
      if (btn) btn.click();
    }
  });
  document.addEventListener('ntc:cart-rendered', applyPromoUI);
  applyPromoUI();

  /* ---------------- variant picker ---------------- */
  function initVariantPickers() {
    qsa('[data-variant-picker]').forEach((picker) => {
      const data = JSON.parse(qs('[data-variant-json]', picker).textContent);
      const form = picker.closest('[data-product-root]').querySelector('[data-add-to-cart-form]');
      const idInput = form ? qs('[data-variant-id]', form) : null;

      function selectedValues() {
        return qsa('[data-option-index]', picker)
          .filter((i) => i.checked)
          .sort((a, b) => Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index')))
          .map((i) => i.value);
      }

      function update() {
        const values = selectedValues();
        qsa('.pill, .swatch', picker).forEach((el) => {
          const input = qs('input', el);
          if (input) el.classList.toggle('is-selected', input.checked);
        });
        qsa('[data-option-selected]', picker).forEach((el, i) => {
          if (values[i]) el.textContent = values[i];
        });
        const match = data.variants.find((v) =>
          v.options.every((o, i) => values[i] === undefined || o === values[i])
        );
        const root = picker.closest('[data-product-root]');
        const priceEl = qs('[data-variant-price]', root);
        const button = form ? qs('[data-add-button]', form) : null;
        if (match) {
          if (idInput) idInput.value = match.id;
          if (priceEl) priceEl.innerHTML = match.price_html;
          if (button) {
            button.disabled = !match.available;
            button.textContent = match.available ? 'Add to cart' : "This option isn't available yet";
          }
          const media = qs('[data-variant-image]', root);
          if (media && match.featured_image) media.src = match.featured_image;
          if (window.history.replaceState) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', url.toString());
          }
        } else if (button) {
          button.disabled = true;
          button.textContent = "This option isn't available yet";
        }
      }

      picker.addEventListener('change', update);
      update();
    });
  }
  initVariantPickers();

  /* ---------------- pdp thumbnails ---------------- */
  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    const root = thumb.closest('[data-product-root]');
    const main = qs('[data-variant-image]', root);
    if (main) main.src = thumb.getAttribute('data-thumb-src');
    qsa('[data-thumb]', root).forEach((t) => t.setAttribute('aria-current', t === thumb ? 'true' : 'false'));
  });

  /* ---------------- predictive search in modal ---------------- */
  let searchTimer;
  const defaultResults = qs('[data-search-results]');
  if (defaultResults) defaultResults.__default = defaultResults.innerHTML;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-search-input]')) return;
    const q = e.target.value.trim();
    const results = qs('[data-search-results]');
    if (!results) return;
    clearTimeout(searchTimer);
    if (results.__default === undefined) results.__default = results.innerHTML;
    if (!q) { results.innerHTML = results.__default; return; }
    searchTimer = setTimeout(async function () {
      const url = window.Shopify.routes.root +
        'search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
      const res = await fetch(url);
      const html = await res.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('[data-search-results]');
      results.innerHTML = fresh ? fresh.innerHTML :
        '<p class="search-modal__none">No matches for "' + q + '".</p>';
    }, 200);
  });
})();
